import { Description } from '@radix-ui/react-dialog';
import { PropsWithChildren } from 'react';

import styles from './modal-components.module.css';

type ModalSubtitleProps = PropsWithChildren;

// Render as the Radix dialog `Description` so the subtitle is wired to the
// content's `aria-describedby`. Without this the dialog points `aria-describedby`
// at a non-existent element, which is both an a11y defect and the source of
// Radix's "Missing `Description`" console warning.
export const ModalSubtitle = ({ children }: ModalSubtitleProps) => (
  <Description asChild>
    <h2 className={styles.subtitle}>{children}</h2>
  </Description>
);
